<template>
  <div>
    <div class="publishBox" v-bind:style="{ minHeight: minheight + 'px' }">
      <Header></Header>
      <div style="border-top:1px solid #f2f5f8">
        <ul class="booklist clearfix">
          <li v-for="(item, index) in booklist" :key="index">
            <dl>
              <dt>
                <a href="javaScript:">
                  <img v-lazy="item.iconUrl" :alt="item.name" />
                </a>
              </dt>
              <dd>
                <a href="javaScript:">
                  <h4 :title="item.name">{{ item.name }}</h4>
                </a>
                <a href="javaScript:">
                  <em class="author">作者：{{ item.author }}</em>
                </a>
              </dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      booklist: [
        {
          author: "南无袈裟理科佛、",
          name: "苗疆道事",
          iconUrl: "https://b.heiyanimg.com/img/1556523373267_1959002881.png"
        },
        {
          author: "白鹭成双",
          name: "草色烟波里",
          iconUrl: "https://b.heiyanimg.com/img/1556523399533_1058225334.jpg"
        },
        {
          author: "十月十二",
          name: "烟雨阁诡怪传说",
          iconUrl: "https://b.heiyanimg.com/img/1557281844780_1039351682.jpg"
        },
        {
          author: "蓝家三少",
          name: "安东侯府",
          iconUrl: "https://b.heiyanimg.com/img/1528684787400_910273237.png"
        },
        {
          author: "江中月影",
          name: "陛下是个窝囊废",
          iconUrl: "https://b.heiyanimg.com/img/1551944421894_1689199671.jpg"
        },
        {
          author: "西风灼灼",
          name: "可爱不可及",
          iconUrl: "https://b.heiyanimg.com/img/1556508733646_426903811.png"
        },
        {
          author: "白鹭成双",
          name: "春日宴",
          iconUrl: "https://b.heiyanimg.com/img/1528686922788_1299233187.jpg"
        },
        {
          author: "蓝家三少",
          name: "簪中案",
          iconUrl: "https://b.heiyanimg.com/img/1557281858712_473150677.jpg"
        },
        {
          author: "白鹭成双",
          name: "风月不相关",
          iconUrl: "https://b.heiyanimg.com/img/1551944297053_832037566.png"
        },
        {
          author: "耳东水寿",
          name: "民调局异闻录之勉传",
          iconUrl: "https://b.heiyanimg.com/img/1533020286233_1626546093.png"
        }
      ],
      minheight: null
    };
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.minheight = document.documentElement.clientHeight - 200; //监听浏览器窗口变化
    window.onresize = () => {
      this.minheight = document.documentElement.clientHeight - 200;
    };
  }
};
</script>

<style lang="stylus" scoped>
.publishBox
    background #fff
.booklist
    padding-top 60px
    width 1016px
    margin 1px auto 30px
    li
        float left
        margin 0 79px 30px 0
        width 140px
        &.big
            width 176px
            margin 0 28px 0px 0
            dl
                dt
                    height 258px
                    img
                        width 176px
                        height 236px
        &:nth-child(5n)
            margin-right 0px
        &:hover
            dl
                dt
                    transform translate3d(0, -3%, 0)
        dl
            dt
                transition all 0.17s ease-in-out
                -webkit-transform translateZ(0)
                -webkit-transition all 0.17s ease-in-out
                transform translateZ(0)
                height 200px
                img
                    width 140px
                    height 182px
                    box-shadow 0 5px 5px rgba(0, 0, 0, 0.35)
            dd
                h4
                    height 28px
                    line-height 28px
                    text-overflow ellipsis
                    white-space nowrap
                    overflow hidden
                    font-size 16px
                    color #333
                    margin-bottom 6px
                    &:hover
                        color #48a2df
                .author
                    display block
                    white-space nowrap
                    font-size 13px
                    margin-bottom 12px
                    text-overflow ellipsis
                    overflow hidden
                    color #999
                    &:hover
                        color #707070
                p
                    height 54px
                    text-align justify
                    display -webkit-box
                    -webkit-line-clamp 3
                    -webkit-box-orient vertical
                    line-height 18px
                    font-size 12px
                    margin-bottom 12px
                    text-overflow ellipsis
                    overflow hidden
                    word-break break-all
                    word-wrap break-word
                    color #999
                .tag
                    display inline-block
                    height 18px
                    border 1px solid #48a2df
                    border-radius 2px
                    color #48a2df
                    padding 0 7px
                    margin 0 6px 0 0
                    font-size 14px
</style>
